<template>
  <div class="container">
    <div class="page-title">会员中心</div>
    <div class="content">
        <div class="item">
          <span class="item-label">企业名称：</span>
          <span class="item-value">{{ userData.companyName }}</span>
        </div>
        <div class="item">
          <span class="item-label">会员类型：</span>
          <span class="item-value">菜单案例vip会员</span>
        </div>
        <div class="item">
          <span class="item-label">开始时间：</span>
          <span class="item-value">{{ userData.startDate}}</span>
        </div>
        <div class="item">
          <span class="item-label">结束时间：</span>
          <span class="item-value">{{ userData.endDate}}</span>
        </div>
        <div class="item">
          <span class="item-label">总下载次数：</span>
          <span class="item-value">{{ userData.sumCount }}</span>
        </div>
        <div class="item">
          <span class="item-label">总剩余次数：</span>
          <span class="item-value">{{ userData.downCount }}</span>
        </div>
        <div class="item">
          <span class="item-label">当日总下载次数：</span>
          <span class="item-value">{{ userData.dayMaxCount }}</span>
        </div>
        <div class="item">
          <span class="item-label">当日剩余下载次数：</span>
          <span class="item-value">{{ userData.dayLeftoverCount }}</span>
        </div>
      <div class="item" v-if="contractUrl">
        <span class="item-label"  style="color: #409EFF;cursor: pointer;" @click="download">点击下载合同</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        userData: {},
        contractUrl: ''
      };
    },
    activated () {
      this.queryUserInfo();
    },
    methods: {
      download(){
        // window.open(`${location.origin}/file/agreement.html`)
        window.open(this.contractUrl)
      },
      queryUserInfo(){
        this.listLoading = true;
        this.$http.post(`/user/userVip`, {
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('userVip res====',res)
            if (res.data.code === 'ok') {
              this.contractUrl = res.data.data && res.data.data.contractUrl;
              // this.userData = {...res.data.data, name: window.sessionStorage.userName};
              this.userData = res.data.data;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
    },
    watch: {

    },
    filters: {
      rTime(data){
        if(!data) return
        var dt = new Date(data);
        var y = dt.getFullYear();
        var m = (dt.getMonth()+1).toString().padStart(2,"0");
        var d = dt.getDate().toString().padStart(2,"0");
        return `${y}-${m}-${d}`;
      },
    }
  };
</script>
<style lang="less" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    margin:30px 0 0 30px;
  }
  .item {
    display: flex;
    font-size: 16px;
    margin-bottom: 20px;
    color: #000000;
    .item-label {
      text-align: right;
      min-width: 150px;
      padding-right: 10px;
    }
    .item-value {
      color: #000000;
      font-weight: bold;
    }
  }
</style>
